import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueAnalytics from 'vue-analytics'
import VueWow from 'vue-wow'

Vue.use(BootstrapVue)
Vue.use(VueWow)
/*Vue.use(VueAnalytics, {
  id: 'UA-145841483-1',
  router
})*/

Vue.config.productionTip = false


let allowed_langs = ['en', 'pt'];

/*Vue.prototype.goToTop = () => window.scrollTo({
  top: 0, 
  left: 0, 
  behavior: 'smooth'
});*/

Vue.prototype.goToTop = () => window.scrollTo(0, 0);

Vue.mixin({
	methods: {
		is_ie() {
	        var ua = window.navigator.userAgent;

			// IOS
			if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
				return false;
			}

			if(/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
				return false;
			}

			var iDevices = [
				'iPad Simulator',
				'iPhone Simulator',
				'iPod Simulator',
				'iPad',
				'iPhone',
				'iPod'
			];
			
			if (!!navigator.platform) {
				while (iDevices.length) {
				  if (navigator.platform === iDevices.pop()){
						return false;
					}
				}
			}
			

	        var msie = ua.indexOf('MSIE ');
	        if (msie > 0) {
	            // IE 10 or older => return version number
	            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	        }
	

	        var trident = ua.indexOf('Trident/');
	        if (trident > 0) {
	            // IE 11 => return version number
	            var rv = ua.indexOf('rv:');
	            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	        }

	        var edge = ua.indexOf('Edge/');
	        if (edge > 0) {
	           // Edge (IE 12+) => return version number
	           return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	        }

	        // other browser
	        return false;
	    }
	}
});

Vue.prototype.isIE = Vue.options.methods.is_ie();

router.beforeEach((to, from, next) => {
	
	if(allowed_langs.indexOf(to.params.lang) === -1) {
		router.push(from.fullPath);
		return;
	}
	
	/*ga('set', 'page', to.fullPath);
	ga('send', 'pageview');*/

	if(to.params.lang !== from.params.lang) {
		localStorage.setItem('lang', to.params.lang);
		Vue.prototype.configs = require('./configs/' +localStorage.lang+ '.js');
	}
	else if(typeof Vue.prototype.configs === 'undefined') {
		Vue.prototype.configs = require('./configs/' +localStorage.lang+ '.js');
	}
	document.title = to.meta.title;

	/*if(to.meta.has_map && document.getElementById('goo_maps') === null) {
		var script = document.createElement('script');
		script.id = 'goo_maps';
		script.type = 'text/javascript';
		script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDKp7l2AOPzSsvft3GkwNW-fIwHooJ6R8A';    
		document.getElementsByTagName('head')[0].appendChild(script);
	}*/

	next();
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
